import React from 'react';
import { Phone, CalendarHeart } from 'lucide-react';
import { business } from '../mock';

export default function MobileCTABar({ onSchedule }) {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40"
      style={{
        backgroundColor: 'rgba(255,255,255,0.96)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid var(--line)',
        boxShadow: '0 -8px 24px -16px rgba(30,59,44,0.5)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <div className="flex items-center gap-3 px-4 py-3">
        <a
          href={business.phoneHref}
          className="btn-outline flex-1 justify-center"
          style={{ padding: '13px 14px' }}
        >
          <Phone size={18} /> Call
        </a>
        <button
          onClick={onSchedule}
          className="btn-sage flex-1 justify-center"
          style={{ padding: '13px 14px' }}
        >
          <CalendarHeart size={18} /> Schedule
        </button>
      </div>
    </div>
  );
}
